export default __webpack_public_path__ + "d1ca061cd23096c8678fa0ed897f5973.svg";